import ExternalDeliveries from './external-deliveries';
import Orders from './orders';
import Receipts from './receipts';

export default {
  ExternalDeliveries,
  Orders,
  Receipts,
};
